import {graphql} from 'react-relay';

export const BaselineEditPageQuery = graphql`
	query BaselineEditPageQuery($projectId: String, $hasDeliverablesFeature: Boolean!, $baselineVersionId: ID) {
		viewer {
			actualPersonId
			component(name: "edit_baseline")
			project(id: $projectId) {
				id
				baselineVersions {
					id
					isStandard
				}
			}
			...BaselineEditPage_viewer
				@arguments(
					projectId: $projectId
					hasDeliverablesFeature: $hasDeliverablesFeature
					baselineVersionId: $baselineVersionId
				)
		}
	}
`;
